export enum DocumentViewerType {
  Unknown = 0,
  ARender = 1,
  ARenderCompareMode = 2,
  Original = 3,
  ARenderRedactionMode = 4,
  ARenderPageManipulationMode = 5,
}
